import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost, handleChangeValue, handlePatch, handleDateChangeEvent } from '../../../../utils/AxiosUtil';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import NewAgainField from '../../../common/inputfields/NewAgainField';
import ErrorAwareAmountField from '../../../common/inputfields/ErrorAwareAmountField';
import { toDateFormat, trimSpaces } from '../../../../utils/Util';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import MyCreatableAutocomplete from '../../../common/inputfields/MyAutocomplete';
import axios from 'axios';

class ModifyCar extends Component {

    state = {
        licenseNumber: this.props.row.licenseNumber,
        purchaseDate: this.props.row.purchaseDate && new Date(this.props.row.purchaseDate),
        vehicleSafetyInspectionDeadline: this.props.row.vehicleSafetyInspectionDeadline && new Date(this.props.row.vehicleSafetyInspectionDeadline),
        nextServiceDate: this.props.row.nextServiceDate && new Date(this.props.row.nextServiceDate),
        nextServiceKm: this.props.row.nextServiceKm,
        comment: this.props.row.comment,
        selectedEmployee: { value: this.props.row.defaultDriverEmployeeId, label: this.props.row.defaultDriverEmployeeName },
        errors: new Map(),
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = '/api/car';
        const requestObject = {
            "privateId": this.props.row.privateId,
            "licenseNumber": this.state.licenseNumber,
            "purchaseDate": this.state.purchaseDate,
            "vehicleSafetyInspectionDeadline": this.state.vehicleSafetyInspectionDeadline,
            "nextServiceDate": this.state.nextServiceDate,
            "nextServiceKm": trimSpaces(this.state.nextServiceKm),
            "defaultDriverEmployeeId": this.state.selectedEmployee?.value,
            "comment": this.state.comment,
            "active": this.props.row.active,
            "initKm": this.props.row.initKm
        };
        await handlePatch(path, requestObject, this);
    };

    promiseEmployeeOptions = async () => {
        const params = {
            haveDriverLicense: true
        };
        const response = await axios.get('/api/employees', { params })
        return response.data.map(resp => ({
            label: resp.employee.name,
            value: resp.employee.privateId
        }));
    };

    handleEmployeeSelected = (e, v) => {
        console.log(v);
        this.setState({ selectedEmployee: v })
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            required
                            name="licenseNumber"
                            label="Rendszám"
                            errors={this.state.errors}
                            value={this.state.licenseNumber}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            id="purchaseDate"
                            name="purchaseDate"
                            label="Vásárlás dátuma"
                            errors={this.state.errors}
                            value={this.state.purchaseDate}
                            onChange={v => handleDateChangeEvent(v, "purchaseDate", this)}
                        />
                    </div>
                    <div className='input-group'>
                        <MyCreatableAutocomplete
                            value={this.state.selectedEmployee}
                            defaultvale={this.state.selectedEmployee}
                            getOptions={this.promiseEmployeeOptions}
                            onChange={this.handleEmployeeSelected}
                            label={'Söfőr'}
                            required={false}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            id="vehicleSafetyInspectionDeadline"
                            name="vehicleSafetyInspectionDeadline"
                            label="Műszaki lejárat dátuma"
                            errors={this.state.errors}
                            value={this.state.vehicleSafetyInspectionDeadline}
                            onChange={v => handleDateChangeEvent(v, "vehicleSafetyInspectionDeadline", this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            id="nextServiceDate"
                            name="nextServiceDate"
                            label="Következő service dátuma"
                            errors={this.state.errors}
                            value={this.state.nextServiceDate}
                            onChange={v => handleDateChangeEvent(v, "nextServiceDate", this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            name="nextServiceKm"
                            label="Következő service km"
                            errors={this.state.errors}
                            value={this.state.nextServiceKm}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Megjegyzés"
                            errors={this.state.errors}
                            value={this.state.comment}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Módosít
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(ModifyCar);
